import { useEffect, useCallback, useState } from 'react';

import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as T from 'fp-ts/Task';
import * as TE from 'fp-ts/TaskEither';

import { executeTask, BSTaskFromIO } from '../../util/bs-fp';
import { AsyncData } from '../AsyncData';
import { BSTask } from '../types';

export function useAsyncState<T>(asyncFunction: () => BSTask<T>) {
  const [state, updateState] = useState<AsyncData<T>>({ inProgress: true });

  const fetchTask = useCallback(() => {
    return pipe(
      BSTaskFromIO(() => updateState({ inProgress: true })),
      TE.chain(() => asyncFunction()),
      T.map(
        E.fold(
          (error) => updateState({ error, inProgress: false }),
          (data) => updateState({ data, inProgress: false })
        )
      )
    );
  }, [updateState, asyncFunction]);

  useEffect(() => {
    executeTask(fetchTask());
  }, [fetchTask]);

  return state;
}
